import { useGlobalToast } from './hooks';
import { Toast } from 'views/components/atoms/toast';

export const GlobalToast = () => {
  const toastProps = useGlobalToast();

  return <Toast {...toastProps} />;
};
